import { GridColDef } from "@material-ui/data-grid";

export const columns: GridColDef[] = [
  {
    field: "userName",
    headerName: "Nome",
    width: 350,
  },
  {
    field: "clientName",
    headerName: "Cliente",
    width: 350,
  },
  {
    field: "projectName",
    headerName: "Projeto",
    width: 350,
  },
  {
    field: "allocationTime",
    headerName: "Horas alocadas",
    width: 350,
  },
  {
    field: "timeWorked",
    headerName: "Total de horas",
    width: 350,
  },
  {
    field: "timeApproved",
    headerName: "Horas aprovadas",
    editable: true,
  },
  {
    field: "url_statement",
    headerName: "Nota Fiscal",
  },
  {
    field: "payment_amount",
    headerName: "Valor da Nota Fiscal",
  },
];

export const IOptionList = [
  {
    id: 1,
    label: "Acima do Normal",
  },
  {
    id: 2,
    label: "Abaixo do Normal",
  },
  {
    id: 3,
    label: "Normal",
  },
  {
    id: 4,
    label: "Todos",
  },
];
